import common from "../common";
import Scene from "./Scene";
import Dorothy from "../actors/Dorothy";
import ParticleEmitter from "../reusableModules/ParticleEmitter";

export default class SplashScene extends Scene {
    constructor() {
        super();

        this._logo = null;
        this._muteButton = null;
        this._playButton = null;
    }

    init() {
        super.init();
        this.addSplashSprites();

        let states = new P3.ButtonStates();
        states.normal = P3.assets.texture("btn_primary_large_off");
        states.over = P3.assets.texture("btn_primary_large_over");
        states.down = P3.assets.texture("btn_primary_large_down");
        states.icon = P3.assets.texture("icon_play_large_off");

        this._playButton = new P3.Button(states);
        this._playButton.visible = false;
        this._playButton.signals.click.add(this.onPlayButtonClick, this);
        this.addChild(this._playButton);

        states = new P3.ButtonStates();
        states.normal = P3.assets.texture("btn_primary_small_over");
        states.over = P3.assets.texture("btn_primary_small_over");
        states.down = P3.assets.texture("btn_primary_small_down");
        states.icon = P3.assets.texture("icon_sound_off");
        states.iconAlt = P3.assets.texture("icon_mute_off");

        this._muteButton = new P3.MuteButton(states);
        this._muteButton.visible = false;
        this.addChild(this._muteButton);
    }

    destroy() {
        super.destroy();
    }

    resize() {
        super.resize();

        console.log("resize");

        this._playButton.x = common.STAGE_WIDTH  * 0.5;
        this._playButton.y = common.STAGE_HEIGHT * 0.5 + 225;

        this._muteButton.x = (common.STAGE_WIDTH + P3.View.width) * 0.5 - 150;
        this._muteButton.y = (common.STAGE_HEIGHT - P3.View.height) * 0.5 + 100;
    }

    animateIn() {
        let newTween = (button, easing)=>{
            return new P3.utils.TWEEN.Tween(button.scale, this.tweens)
                .to({
                    x: 1,
                    y: 1
                }, 340)
                .easing(easing)
                .yoyo(false)
                .delay(0)
                .onStart(()=> {
                    button.visible = true;
                });
        };

        let self = this;
        //===== PLAY BUTTON ======
        this._playButton.scale.set(0);
        let playTween = newTween(this._playButton, P3.utils.Easing.Back3.Out);

        //===== MUTE BUTTON ======
        this._muteButton.scale.set(0);
        let muteTween = newTween(this._muteButton, P3.utils.Easing.Back2.Out);

        muteTween.start();
        playTween.start();
    }

    update() {
        super.update();
        this._dorothy.update(P3.Ticker.dt);
    }

    onPlayButtonClick() {
        this.signals.next.dispatch(this);
        P3.audio.playSound("sfx_btn_accept_00");
    }

    animateObjects(object){
        let newTime = (min, max)=>{
            return Math.floor(Math.random() * (max - min + 1)) + min;
        };
        let time = newTime(3000, 4000);

        let up = new P3.utils.TWEEN.Tween(object, this.tweens)
            .to({
                y: object.y - 10
            }, time)
            .easing(P3.utils.TWEEN.Easing.Quadratic.InOut);

        let down = new P3.utils.TWEEN.Tween(object, this.tweens)
            .to({
                y: object.y + 10
            }, time)
            .easing(P3.utils.TWEEN.Easing.Quadratic.InOut);

        up.chain(down);
        down.chain(up);
        up.start();
    }

    addSplashSprites(){
        let newSprite = (texture, position, animate = false)=>{
            let sprite = new PIXI.Sprite(P3.assets.texture(texture));
            sprite.anchor.set(0.5);
            sprite.position.set(position.x, position.y);

            animate && this.animateObjects(sprite);

            this.addChild(sprite);
            return sprite
        };

        let bk = newSprite('bg_splash', {x: common.STAGE_WIDTH * 0.5, y: common.STAGE_HEIGHT * 0.5});
        bk.width = 1900;
        newSprite('lion', {x: common.STAGE_WIDTH * 0.5 - 375, y: common.STAGE_HEIGHT * 0.5 + 175});
        newSprite('scarecrow', {x: common.STAGE_WIDTH * 0.5 - 500, y: common.STAGE_HEIGHT * 0.5 + 175});

        let strawberry = newSprite('ing_strawberry_shelf', {x: common.STAGE_WIDTH * 0.5 + 225, y: common.STAGE_HEIGHT * 0.5 + 250});
        strawberry.scale.set(0.9);
        strawberry.rotation = common.deg2rad(45);
        this.animateObjects(strawberry);

        newSprite('rolling_pin', {x: common.STAGE_WIDTH * 0.5 + 425, y: common.STAGE_HEIGHT * 0.5 - 200}, true);
        newSprite('orange', {x: common.STAGE_WIDTH * 0.5 + 225, y: common.STAGE_HEIGHT * 0.5 - 275}, true);
        newSprite('egg_001', {x: common.STAGE_WIDTH * 0.5 - 150, y: common.STAGE_HEIGHT * 0.5 - 275}, true);
        newSprite('bowl', {x: common.STAGE_WIDTH * 0.5 - 200, y: common.STAGE_HEIGHT * 0.5 + 175});
        newSprite('sparkles', {x: common.STAGE_WIDTH * 0.5, y: common.STAGE_HEIGHT * 0.5});
        newSprite('egg_002', {x: common.STAGE_WIDTH * 0.5 - 225, y: common.STAGE_HEIGHT * 0.5 - 225}, true);
        newSprite('milk', {x: common.STAGE_WIDTH * 0.5 - 300, y: common.STAGE_HEIGHT * 0.5 - 350}, true);
        newSprite('cookie_002', {x: common.STAGE_WIDTH * 0.5, y: common.STAGE_HEIGHT * 0.5 + 100}, true);
        newSprite('cookie_001', {x: common.STAGE_WIDTH * 0.5 - 375, y: common.STAGE_HEIGHT * 0.5 - 150}, true);

        let whisk = newSprite('whisk_2', {x: common.STAGE_WIDTH * 0.5 - 150, y: common.STAGE_HEIGHT * 0.5 + 75});
        let whiskTween = new P3.utils.TWEEN.Tween(whisk, this.tweens)
            .to({
                rotation: whisk.rotation + common.deg2rad(5)
            }, 2000)
            .easing(P3.utils.TWEEN.Easing.Quadratic.InOut);

        let whiskTween2 = new P3.utils.TWEEN.Tween(whisk, this.tweens)
            .to({
                rotation: whisk.rotation + common.deg2rad(-5)
            }, 2000)
            .easing(P3.utils.TWEEN.Easing.Quadratic.InOut);

        whiskTween.chain(whiskTween2);
        whiskTween2.chain(whiskTween);
        whiskTween.start();

        this._dorothy = new Dorothy();
        this._dorothy.position.set(common.STAGE_WIDTH * 0.5 + 360, common.STAGE_HEIGHT * 0.5 + 450);
        this.addChild(this._dorothy);
        this._dorothy.playSplashIdleAnimation();

        let title = newSprite('title', {x: common.STAGE_WIDTH * 0.5, y: common.STAGE_HEIGHT * 0.5 - 100});
        let titleTween = new P3.utils.TWEEN.Tween(title, this.tweens)
            .to({
                rotation: title.rotation + common.deg2rad(1)
            }, 3000)
            .easing(P3.utils.TWEEN.Easing.Quadratic.InOut);

        let titleTween2 = new P3.utils.TWEEN.Tween(title, this.tweens)
            .to({
                rotation: title.rotation + common.deg2rad(-1)
            }, 3000)
            .easing(P3.utils.TWEEN.Easing.Quadratic.InOut);

        titleTween.chain(titleTween2);
        titleTween2.chain(titleTween);
        titleTween.start();

        let up = new P3.utils.TWEEN.Tween(title, this.tweens)
            .to({
                y: title.y - 5
            }, 3000)
            .easing(P3.utils.TWEEN.Easing.Quadratic.InOut);

        let down = new P3.utils.TWEEN.Tween(title, this.tweens)
            .to({
                y: title.y + 5
            }, 3000)
            .easing(P3.utils.TWEEN.Easing.Quadratic.InOut);

        up.chain(down);
        down.chain(up);
        up.start();
        newSprite('logo', {x: common.STAGE_WIDTH * 0.5, y: common.STAGE_HEIGHT * 0.5 - 300});
    }
}